export default "__VITE_ASSET__7NaW7yJL__"